var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-solicitudes-obras-desktop"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listadoSolicitudesObras,"items-per-page":20},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('opciones',{attrs:{"solicitudObra":item,"firma":_vm.firma}})]}},{key:"item.fechaMemorandum",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(new Date(item.fechaMemorandum).toLocaleDateString())+"\n    ")]}},{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_c('fecha-humano',{attrs:{"fecha":new Date(item.createdAt)}})]}},{key:"item.meta",fn:function(ref){
var item = ref.item;
return [_c('cortar-texto',{attrs:{"texto":item.meta}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }